// Indian mobile numbers: 10 digits, first digit 6-9 (no country code, no
// leading 0 -- the common way people type/paste a number locally).
const INDIAN_PHONE_PATTERN = /^[6-9]\d{9}$/;

export function isValidIndianPhone(phone: string): boolean {
  return INDIAN_PHONE_PATTERN.test(phone.trim());
}

export const INVALID_PHONE_MESSAGE =
  "Enter a valid mobile number: 10 digits starting 6-9, or +country code for an international number";

/** Mirrors the server's app/core/phone.py: Indian mobile (10 digits, 6-9 first,
 * optional 0/91/+91 prefix) or an international number with a leading +.
 * An empty value is valid (the field is optional). */
export function isValidOptionalPhone(phone: string): boolean {
  const compact = phone.trim().replace(/[\s\-().]/g, "");
  if (!compact) return true;
  if (!/^\+?\d+$/.test(compact)) return false;

  let national: string;
  let valid: boolean;
  if (compact.startsWith("+")) {
    const digits = compact.slice(1);
    if (digits.startsWith("91")) {
      national = digits.slice(2);
      valid = INDIAN_PHONE_PATTERN.test(national);
    } else {
      national = digits;
      valid = digits.length >= 8 && digits.length <= 15 && !digits.startsWith("0");
    }
  } else {
    national = compact;
    for (const prefix of ["91", "0"]) {
      if (national.startsWith(prefix) && national.length === prefix.length + 10) {
        national = national.slice(prefix.length);
        break;
      }
    }
    valid = INDIAN_PHONE_PATTERN.test(national);
  }
  return valid && new Set(national).size > 1;
}
